<app-map (onMapClose)="closeCard()" [mapInitialized]="_mapInitialized" [isCard]="true"
  [hasErrorLoadingMap]="_errLoadingMap">
  <mot-autocomplete
    [formControl]="formControl"
    [options]="results$"
    [displayFn]="routePlanningService.displayAddressName"
    (onOptionSelected)="displayAddressMarker($event)"
    fieldClass="w-full px-2 !text-default"
    labelClass="!text-default"
    class="address-autocomplete flex top-4 w-full absolute z-50"
    [label]="data.title"
    [inputTabIndex]="mapAddressSearchTabIndex"
  />
  <div
    class="flex items-center gap-2 bg-darkBlue left-0 right-0 absolute mx-auto z-50 rounded-lg py-3 px-2 w-1/3"
    [ngClass]="isMobile ? 'top-20' : 'bottom-8'"
    [class]="direction">
    <ng-icon name="map-location-dot" class="text-white text-xl" />
    <span class="text-white">{{pickMapLocationText}}</span>
  </div>
</app-map>